import { LS } from "src/config/constants";

export const getFavoriteTokens = () => {
  let tokens = null;
  try {
    tokens = JSON.parse(localStorage.getItem(LS.FAVORITE_TOKEN)) || [];
  } catch (error) {
    tokens = [];
  }
  localStorage.setItem(LS.FAVORITE_TOKEN, JSON.stringify(tokens));
  return tokens;
};

export const addFavoriteToken = (tokenId) => {
  let tokens = getFavoriteTokens();
  tokens.push(tokenId);
  localStorage.setItem(LS.FAVORITE_TOKEN, JSON.stringify(tokens));
  return tokens;
};

export const removeFavoriteToken = (tokenId) => {
  let tokens = getFavoriteTokens();
  const index = tokens.indexOf(tokenId);
  if (index > -1) tokens.splice(index, 1);
  localStorage.setItem(LS.FAVORITE_TOKEN, JSON.stringify(tokens));
  return tokens;
};
